import { TextStyled } from '@nike/nike-design-system-components';

// eslint-disable-next-line react/prop-types
const LineItemAttribute = ({ attributeName, value }) => (
  <div style={{ display: 'flex', gap: '5px', padding: '5px  0' }}>
    <TextStyled appearance='body2Strong'>{attributeName}:</TextStyled>
    <TextStyled appearance='body2'>{value}</TextStyled>
  </div>
);

export default LineItemAttribute;
